import React, { forwardRef, useImperativeHandle } from "react";
import { Card, CardBody } from "reactstrap";

const PortfolioSideNoteSubTypes = forwardRef(({ data, activeColor, portfolioId, updateMutation }, ref) => {
  // Expose handleSave to parent via ref
  useImperativeHandle(ref, () => ({
    handleSave: async () => {
      // TODO: Implement save functionality
      return { success: true };
    }
  }));

  return (
    <Card>
      <CardBody>
        <h5 className="mb-3">Side Note Sub-Types</h5>
        <p className="text-muted">Side note sub-types configuration will be displayed here.</p>
        {/* TODO: Add side note sub-types content */}
      </CardBody>
    </Card>
  );
});

PortfolioSideNoteSubTypes.displayName = "PortfolioSideNoteSubTypes";

export default PortfolioSideNoteSubTypes;

